export const capPattern = '[0-9][0-9][0-9][0-9][0-9]';
export const passwordPattern: RegExp = /^(?:(?=.*\d)(?=.*[A-Z]).{8,})/;
export const zeroCentoPattern = '^([0-9]|[1-9][0-9]|100)$';
export const formatoData: RegExp = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
export const formatoEmail: RegExp = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
export const iban = /^(?:(?:IT|SM)\d{2}[A-Z]\d{22}|CY\d{2}[A-Z]\d{23}|NL\d{2}[A-Z]{4}\d{10}|LV\d{2}[A-Z]{4}\d{13}|(?:BG|BH|GB|IE)\d{2}[A-Z]{4}\d{14}|GI\d{2}[A-Z]{4}\d{15}|RO\d{2}[A-Z]{4}\d{16}|KW\d{2}[A-Z]{4}\d{22}|MT\d{2}[A-Z]{4}\d{23}|NO\d{13}|(?:DK|FI|GL|FO)\d{16}|MK\d{17}|(?:AT|EE|KZ|LU|XK)\d{18}|(?:BA|HR|LI|CH|CR)\d{19}|(?:GE|DE|LT|ME|RS)\d{20}|IL\d{21}|(?:AD|CZ|ES|MD|SA)\d{22}|PT\d{23}|(?:BE|IS)\d{24}|(?:FR|MR|MC)\d{25}|(?:AL|DO|LB|PL)\d{26}|(?:AZ|HU)\d{27}|(?:GR|MU)\d{28})$/;
export const formatoSwift = /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/;
//static codiceFiscale = /^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$/;
export const codiceFiscale = /([a-z]{6}|[A-Z]{6})(l|m|n|p|q|r|s|t|u|v|L|M|N|P|Q|R|S|T|U|V|\d{1})(l|m|n|p|q|r|s|t|u|v|L|M|N|P|Q|R|S|T|U|V|\d{1})(a|b|c|d|e|h|l|m|p|r|s|t|A|B|C|D|E|H|L|M|P|R|S|T)((((l|m|n|p|q|r|s|t|u|v|L|M|N|P|Q|R|S|T|U|V|0|1|2|3|4|5|6)(l|m|n|p|q|r|s|t|u|v|L|M|N|P|Q|R|S|T|U|V|\d{1}))|71|70|TM|Tm|tM|tm|TL|tl|Tl|tL))([a-z]{1}|[A-Z]{1})(L|M|N|P|Q|R|S|T|U|V|\d{1})(l|m|n|p|q|r|s|t|u|v|L|M|N|P|Q|R|S|T|U|V|\d{1})(l|m|n|p|q|r|s|t|u|v|L|M|N|P|Q|R|S|T|U|V|\d{1})([a-z]{1}|[A-Z]{1})/;
export const partitaIva = /^[0-9]{11}$/;
export const codiceFiscalePiva = '^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$|^[0-9]{11}$';
export const _codiceFiscalePiva = /^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$|^[0-9]{11}$/;
export const anno = /^[1-2][0-9]{3}$/;
export const nSentenza = /^[0-9]*\/[1-2][0-9]{3}$/;
export const numberPattern = /^[0-9]*$/;
export const phoneNumberPattern = /^\+{0,1}[0-9]*$/;
export const moneyPattern = /^([0-9]+)|((([1-9][0-9]*)|([0-9]))([,])[0-9]{2})$/;
export const moneyCommaSeparated = /^\d+,\d{2}$/;
export const moneyCommaSeparatedGreaterThanZero = /^\s*(?=.*[1-9])\d*(?:\,\d{1,2})?\s*$/;
export const numbers = /^\d+/;
export const formatoName: RegExp = /^[a-zA-Zàèìòùé ']+$/;
export const numRegex = /^-?\d*[.,]?\d{0,2}$/;

export const validationMessages = {
	maxlength: "validation-maxlength",
	requiredInfoDecreto: "validation-requiredInfoDecreto",
	requiredMail: "validation-requiredMail",
	cfInvalidoFormalmente: "validation-cfInvalidoFormalmente",
	invalidCF: "validation-invalidCF",
	nSentenza: "validation-nSentenza",
	required: "obbligatorio",
	email: "validation-email",
	tel: "validation-tel",
	iban: "validation-iban",
	partitaIVAInvalida: "validation-partitaIVAInvalida",
	money: "validation-money",
	invalidName: "validation-invalidName",
	invalidDate: "validation-invalidDate",
	pattern: "validation-pattern",
	invalidDateFormat: "validation-invalidDateFormat",
	requiredDefinizione: "validation-requiredDefinizione",
	validationServiceFailed: "validation-validationServiceFailed",
	cfValidationPG: "validation-cfValidationPG",
	cfDifferentRichiedente: "validation-cfDifferentRichiedente",
	requiredDomicilio: "validation-requiredDomicilio",
	requiredSede: "validation-requiredSede",
	matDatepickerParse: "validation-invalidDateFormat",
	matDatepickerMax: "error-upper-bound"
}
